// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1GMbX,._1sQ-b{width:354px;width:35.4rem}._1GMbX{display:-ms-flexbox;display:flex;position:fixed;top:0;-ms-flex-pack:justify;background:#1b1b1b;-webkit-box-shadow:0 4px 10px rgba(50,66,121,.05);box-shadow:0 4px 10px rgba(50,66,121,.05);-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-direction:column;flex-direction:column;height:100%;justify-content:space-between;overflow-y:auto;padding:3.2rem;z-index:1030}html[dir=ltr] ._1GMbX{border-bottom-right-radius:16px;border-top-right-radius:16px}html[dir=rtl] ._1GMbX{border-bottom-left-radius:16px;border-top-left-radius:16px}", ""]);
// Exports
exports.locals = {
	"sidebar": "_1GMbX",
	"wrapperSidebar": "_1sQ-b"
};
module.exports = exports;
